module.exports = __webpack_public_path__ + "static/coyote-america-d650cadc691f0892e1448d3651beb24b.jpg";